'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "List", {
    enumerable: true,
    get: function() {
        return List;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useList = require("./useList");
const _renderList = require("./renderList");
const _useListStylesstyles = require("./useListStyles.styles");
const _useListContextValues = require("./useListContextValues");
const List = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useList.useList_unstable)(props, ref);
    const contextValues = (0, _useListContextValues.useListContextValues_unstable)(state);
    (0, _useListStylesstyles.useListStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useListStyles_unstable')(state);
    return (0, _renderList.renderList_unstable)(state, contextValues);
});
List.displayName = 'List';
